import './styles/graphic.scss';

export default function (props, container, isMobile) {
  const { initialWidth } = props;
  const { initialHeight } = props;

  // Update the headline and subhed using the existing HTML structure
  const headline = document.querySelector('.headline');
  const subhed = document.querySelector('.subhed');
  const source = document.querySelector('.source');
  const footnote = document.querySelector('.footnote');

  const initialCities = [
    { name: 'Dallas', st: 'Texas' },
    { name: 'Minneapolis', st: 'Minnesota' },
    { name: 'Chicago', st: 'Illinois' },
    { name: 'Memphis', st: 'Tennessee' },
    { name: 'Cleveland', st: 'Ohio' },
    { name: 'Atlanta', st: 'Georgia' },
    { name: 'Washington', st: '' },
    { name: 'Philadelphia', st: 'Pennsylvania' },
    { name: 'New York', st: 'New York' },
    { name: 'Boston', st: 'Massachusetts' },
    // { name: 'Austin', st: 'Texas' },
    // { name: 'Jacksonville', st: 'Florida' },
    // { name: 'Fort Worth', st: 'Texas' },
    // { name: 'Columbus', st: 'Ohio' },
    // { name: 'Charlotte', st: 'North Carolina' },
  ];

  // Create main container
  const mainContainer = container.append('div')
    .attr('class', 'temperature-table-container');

  // Add search input
  const searchContainer = mainContainer.append('div')
    .attr('class', 'search-container');

  const searchInput = searchContainer.append('input')
    .attr('type', 'text')
    .attr('placeholder', 'Search more than 800 US cities...')
    .attr('class', 'city-search');

  // Add day selector buttons
  const daySelectorContainer = mainContainer.append('div')
    .attr('class', 'day-selector-container');

  // Add table container with better height management
  const tableContainer = mainContainer.append('div')
    .attr('class', 'table-wrapper');

  const table = tableContainer.append('table')
    .attr('class', 'temperature-table');

  // Sort state variables
  const currentSort = { column: 'temperature', direction: 'asc' };

  // Add table header with sortable columns
  const thead = table.append('thead');
  const headerRow = thead.append('tr');

  // City header (sortable)
  const cityHeader = headerRow.append('th')
    .attr('class', 'sortable-header');

  cityHeader.append('span')
    .text('City');

  cityHeader.append('span')
    .attr('class', 'sort-indicator city-sort')
    .style('opacity', '0.4')
    .text('↕');

  // State header (sortable)
  const stateHeader = headerRow.append('th')
    .attr('class', 'sortable-header state-header');

  stateHeader.append('span')
    .text('State');

  stateHeader.append('span')
    .attr('class', 'sort-indicator state-sort')
    .style('opacity', '0.4')
    .text('↕');

  // Temperature header (sortable, default sort)
  const tempHeader = headerRow.append('th')
    .attr('class', 'sortable-header temp-header');

  tempHeader.append('span')
    .text('Feels like (°F)');

  tempHeader.append('span')
    .attr('class', 'sort-indicator temp-sort')
    .style('opacity', '1')
    .text('↑');

  const tbody = table.append('tbody');

  // App state
  let allForecasts = [];
  let currentDayIndex = 0;
  let currentSearchTerm = '';

  // Loading indicator
  const loadingRow = tbody.append('tr');
  loadingRow.append('td')
    .attr('colspan', '3')
    .style('padding', '30px')
    .style('text-align', 'center')
    .style('color', '#666')
    .style('font-style', 'italic')
    .text('Loading temperature data...');

  // NWS color data (summer scale, using temperature + 5°F for enhanced heat perception)
  const nwsColors = {
    135: [160, 8, 2], 134: [163, 9, 2], 133: [165, 10, 2], 132: [168, 11, 2], 131: [172, 13, 2], 130: [175, 14, 2], 129: [178, 15, 2], 128: [180, 16, 2], 127: [185, 18, 2], 126: [187, 19, 2], 125: [190, 20, 2], 124: [193, 22, 2], 123: [198, 26, 2], 122: [200, 28, 2], 121: [202, 30, 2], 120: [205, 32, 2], 119: [210, 36, 2], 118: [213, 38, 2], 117: [215, 40, 2], 116: [218, 42, 2], 115: [223, 46, 2], 114: [225, 48, 2], 113: [228, 50, 2], 112: [230, 52, 2], 111: [235, 56, 0], 110: [238, 58, 0], 109: [240, 60, 0], 108: [242, 65, 0], 107: [244, 75, 0], 106: [246, 80, 0], 105: [248, 90, 0], 104: [249, 100, 0], 103: [251, 120, 0], 102: [252, 130, 0], 101: [252, 140, 0], 100: [253, 150, 0], 99: [254, 170, 0], 98: [254, 180, 0], 97: [255, 185, 0], 96: [255, 190, 0], 95: [255, 200, 0], 94: [255, 210, 0], 93: [255, 215, 0], 92: [255, 220, 0], 91: [255, 230, 0], 90: [255, 235, 0], 89: [255, 240, 0], 88: [255, 245, 0], 87: [255, 255, 0], 86: [253, 251, 1], 85: [250, 248, 1], 84: [248, 245, 2], 83: [243, 238, 3], 82: [240, 235, 3], 81: [238, 233, 3], 80: [235, 230, 4], 79: [220, 225, 5], 78: [210, 223, 5], 77: [200, 220, 5], 76: [185, 218, 4], 75: [160, 213, 3], 74: [145, 210, 3], 73: [133, 209, 3], 72: [120, 208, 3], 71: [95, 205, 3], 70: [78, 202, 2], 69: [65, 199, 2], 68: [55, 197, 1], 67: [39, 195, 1], 66: [30, 195, 1], 65: [25, 193, 6], 64: [20, 192, 10], 63: [10, 192, 15], 62: [7, 193, 23], 61: [5, 195, 30], 60: [0, 197, 40], 59: [0, 203, 60], 58: [0, 205, 70], 57: [0, 207, 85], 56: [1, 210, 100], 55: [1, 215, 134], 54: [1, 218, 145], 53: [1, 220, 167], 52: [1, 220, 174], 51: [1, 220, 186], 50: [1, 220, 198], 49: [1, 218, 205], 48: [1, 215, 212], 47: [0, 210, 228], 46: [0, 207, 234], 45: [0, 205, 240], 44: [0, 201, 243], 43: [1, 195, 242], 42: [2, 193, 240], 41: [3, 191, 235], 40: [5, 189, 230], 39: [7, 182, 220], 38: [9, 171, 218], 37: [10, 160, 215], 36: [11, 150, 213], 35: [13, 130, 205], 34: [18, 110, 198], 33: [20, 100, 195], 32: [23, 95, 193], 31: [25, 90, 190], 30: [30, 80, 180], 29: [33, 73, 175], 28: [35, 65, 170], 27: [38, 60, 165], 26: [43, 50, 155], 25: [45, 45, 150], 24: [50, 40, 151], 23: [55, 35, 152], 22: [60, 25, 154], 21: [65, 20, 156], 20: [70, 15, 158], 19: [75, 18, 160], 18: [85, 23, 164], 17: [90, 25, 166], 16: [95, 28, 168], 15: [99, 30, 170], 14: [108, 35, 174], 13: [112, 38, 176], 12: [117, 40, 178], 11: [122, 43, 180], 10: [130, 48, 184], 9: [135, 50, 185], 8: [140, 54, 186], 7: [146, 58, 187], 6: [155, 65, 189], 5: [160, 68, 190], 4: [164, 72, 191], 3: [169, 75, 192], 2: [178, 82, 195], 1: [182, 86, 196], 0: [186, 88, 197], [-1]: [191, 90, 198], [-2]: [197, 95, 200], [-3]: [200, 98, 205], [-4]: [202, 100, 210], [-5]: [205, 103, 211], [-6]: [209, 107, 213], [-7]: [211, 110, 215], [-8]: [214, 113, 217], [-9]: [216, 115, 220], [-10]: [221, 120, 225], [-11]: [224, 123, 226], [-12]: [227, 125, 227], [-13]: [229, 128, 229], [-14]: [233, 132, 233], [-15]: [235, 135, 235], [-16]: [237, 138, 237], [-17]: [239, 140, 239], [-18]: [240, 143, 240], [-19]: [243, 145, 243], [-20]: [248, 150, 248], [-21]: [250, 160, 249], [-22]: [253, 178, 253], [-23]: [255, 180, 255], [-24]: [255, 190, 255], [-25]: [255, 200, 255],
  };

  // Function to get temperature background color and text color (NWS standards with 5°F shift)
  function getTemperatureStyles(temp) {
    // Use temperature + 5°F for enhanced heat perception
    const adjustedTemp = Math.round(temp + 5);

    // Find the closest temperature in our NWS color data
    let closestTemp = adjustedTemp;
    if (!nwsColors[adjustedTemp]) {
      // Find closest available temperature
      const availableTemps = Object.keys(nwsColors).map(t => parseInt(t));
      closestTemp = availableTemps.reduce((prev, curr) => (Math.abs(curr - adjustedTemp) < Math.abs(prev - adjustedTemp) ? curr : prev));
    }

    const rgb = nwsColors[closestTemp];
    const bgColor = `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`;

    // Calculate text color based on brightness
    const brightness = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
    const textColor = brightness > 128 ? '#000000' : '#ffffff';

    return { bg: bgColor, text: textColor };
  }

  // Function to format the UTC date string
  function formatForecastDate(utcDate) {
    const date = new Date(`${utcDate.replace(' ', 'T')}Z`);
    const options = {
      weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
    };
    return `Forecast for ${date.toLocaleDateString('en-US', options)}`;
  }

  // Function to sort cities
  function sortCities(cities, column, direction) {
    const sortedCities = cities.slice(); // Create a copy

    sortedCities.sort((a, b) => {
      let aVal; let
        bVal;

      if (column === 'city') {
        aVal = a.name.toLowerCase();
        bVal = b.name.toLowerCase();
      } else if (column === 'state') {
        aVal = (a.st || '').toLowerCase();
        bVal = (b.st || '').toLowerCase();
      } else if (column === 'temperature') {
        aVal = a.temperature_f;
        bVal = b.temperature_f;
      }

      if (direction === 'asc') {
        if (aVal < bVal) return -1;
        if (aVal > bVal) return 1;
        return 0;
      }
      if (aVal > bVal) return -1;
      if (aVal < bVal) return 1;
      return 0;
    });

    return sortedCities;
  }

  // Function to update sort indicators
  function updateSortIndicators(column, direction) {
    // Reset all indicators
    thead.selectAll('.sort-indicator')
      .style('opacity', '0.3')
      .text('↕');

    // Update the active column indicator
    let activeIndicator;
    if (column === 'city') {
      activeIndicator = thead.select('.city-sort');
    } else if (column === 'state') {
      activeIndicator = thead.select('.state-sort');
    } else if (column === 'temperature') {
      activeIndicator = thead.select('.temp-sort');
    }

    if (activeIndicator) {
      activeIndicator
        .style('opacity', '1')
        .text(direction === 'asc' ? '↑' : '↓');
    }
  }

  // Function to get initial cities from all cities
  function getInitialCities(cities) {
    const result = [];
    const initialCityKeys = new Set(initialCities.map(c => `${c.name.toLowerCase()}|${c.st.toLowerCase()}`));

    for (let i = 0; i < cities.length; i++) {
      const city = cities[i];
      const cityKey = `${city.name.toLowerCase()}|${(city.st || '').toLowerCase()}`;
      if (initialCityKeys.has(cityKey)) {
        result.push(city);
      }
    }

    // For debugging: log what we found
    console.log('Found', result.length, 'initial cities:', result.map(c => `${c.name}, ${c.st}`));

    return result;
  }

  // Function to get filtered cities based on current search term
  function getFilteredCities(cities) {
    if (currentSearchTerm === '') {
      // No search - show initial cities
      return getInitialCities(cities);
    }
    // Active search - show all matching results
    return cities.filter(city => city.name.toLowerCase().indexOf(currentSearchTerm) !== -1
        || (city.st || '').toLowerCase().indexOf(currentSearchTerm) !== -1);
  }

  // Function to force Pym height recalculation
  function recalculateHeight() {
    if (window.pymChild) {
      setTimeout(() => { window.pymChild.sendHeight(); }, 50);
      setTimeout(() => { window.pymChild.sendHeight(); }, 150);
      setTimeout(() => { window.pymChild.sendHeight(); }, 300);
      setTimeout(() => { window.pymChild.sendHeight(); }, 500);
      setTimeout(() => { window.pymChild.sendHeight(); }, 1000);
    }
  }

  // Function to render table rows
  function renderRows(filteredCities) {
    // Clear existing rows
    tbody.selectAll('tr').remove();

    // Add city rows
    const rows = tbody.selectAll('tr')
      .data(filteredCities)
      .enter()
      .append('tr');

    // City name
    rows.append('td')
      .text(d => d.name);

    // State
    rows.append('td')
      .attr('class', 'state-cell')
      .text(d => (d.st == null ? 'DC' : d.st));

    // Temperature with color coding - colored background boxes
    const tempCells = rows.append('td')
      .attr('class', 'temperature-cell');

    tempCells.append('span')
      .attr('class', 'temp-badge')
      .style('background-color', (d) => {
        const styles = getTemperatureStyles(d.temperature_f);
        return styles.bg;
      })
      .style('color', (d) => {
        const styles = getTemperatureStyles(d.temperature_f);
        return styles.text;
      })
      .html(d => `${Math.round(d.temperature_f)}<span style="padding-left: 2px; letter-spacing: -1px;">°F</span>`);
  }

  // Fetch data using XMLHttpRequest (compatible with ancient browsers/Node)
  const xhr = new XMLHttpRequest();
  xhr.open('GET', 'https://ix.cnn.io/data/apparent-temperature/city_forecasts.json', true);

  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
        try {
          const data = JSON.parse(xhr.responseText);
          allForecasts = data.forecasts;

          // Update source with delay to avoid interfering with initial page load
          if (source && data.source) {
            setTimeout(() => {
              source.textContent = `Source: ${data.source}`;
            }, 500);
          }

          // Get cities from the first forecast
          let cities = [];
          if (data.forecasts && data.forecasts.length > 0 && data.forecasts[0].cities) {
            cities = data.forecasts[0].cities;
          }

          // Master update function
          function updateDisplay(dayIndex) {
            currentDayIndex = dayIndex;

            // Error checking
            if (!allForecasts || !allForecasts[dayIndex]) {
              console.error('No forecast data available for day index:', dayIndex);
              return;
            }

            const forecast = allForecasts[dayIndex];
            if (!forecast.cities) {
              console.error('No cities data available for forecast:', forecast);
              return;
            }

            const { cities } = forecast;

            // Remove loading row if it exists
            loadingRow.remove();

            // Update subhead with forecast date
            if (footnote) {
              const dateString = formatForecastDate(forecast.forecast_time_utc);
              footnote.textContent = `${dateString} | Last updated: ${data.last_updated_str}. Only includes cities in the contiguous US with populations of more than 50,000.`;
            }

            // Show filtered cities based on current search
            const filteredCities = getFilteredCities(cities);
            const sortedCities = sortCities(filteredCities, currentSort.column, currentSort.direction);

            renderRows(sortedCities);

            // Update button styles
            daySelectorContainer.selectAll('.day-button')
              .classed('active', (d, i) => i === dayIndex);

            recalculateHeight();
          }

          // Create day selector buttons
          const buttons = daySelectorContainer.selectAll('.day-button')
            .data(allForecasts)
            .enter()
            .append('button')
            .attr('class', 'day-button')
            .text((d) => {
              const date = new Date(`${d.forecast_time_utc.replace(' ', 'T')}Z`);
              return date.toLocaleDateString('en-US', { weekday: 'long' });
            });

          // Add click handlers with explicit index tracking
          buttons.each(function (d, i) {
            const button = this;
            button.addEventListener('click', () => {
              // Update search term from input before changing day
              currentSearchTerm = searchInput.node().value.toLowerCase().trim();
              updateDisplay(i);
            });
          });

          // Initial Display
          updateDisplay(0);

          // Add click handlers for sortable headers
          cityHeader.on('click', () => {
            if (currentSort.column === 'city') {
              currentSort.direction = currentSort.direction === 'asc' ? 'desc' : 'asc';
            } else {
              currentSort.column = 'city';
              currentSort.direction = 'asc';
            }
            updateSortIndicators(currentSort.column, currentSort.direction);

            // Re-render the current view with the new sort order
            updateDisplay(currentDayIndex);
          });

          stateHeader.on('click', () => {
            if (currentSort.column === 'state') {
              currentSort.direction = currentSort.direction === 'asc' ? 'desc' : 'asc';
            } else {
              currentSort.column = 'state';
              currentSort.direction = 'asc';
            }
            updateSortIndicators(currentSort.column, currentSort.direction);

            // Re-render the current view with the new sort order
            updateDisplay(currentDayIndex);
          });

          tempHeader.on('click', () => {
            if (currentSort.column === 'temperature') {
              currentSort.direction = currentSort.direction === 'asc' ? 'desc' : 'asc';
            } else {
              currentSort.column = 'temperature';
              currentSort.direction = 'desc';
            }
            updateSortIndicators(currentSort.column, currentSort.direction);

            // Re-render the current view with the new sort order
            updateDisplay(currentDayIndex);
          });

          // Add search functionality
          searchInput.on('input', function () {
            // Update global search state
            currentSearchTerm = this.value.toLowerCase().trim();

            // Re-render the current view with the new search term
            updateDisplay(currentDayIndex);
          });

          // Add summary info
          const temperatures = cities.map(d => d.temperature_f);
          const maxTemp = Math.max.apply(Math, temperatures);
          const minTemp = Math.min.apply(Math, temperatures);
          const sum = temperatures.reduce((acc, temp) => acc + temp, 0);
          const avgTemp = sum / temperatures.length;

          // Find hottest and coolest cities
          const hottestCity = cities[0]; // already sorted by temperature desc
          const coolestCity = cities[cities.length - 1];

          // Tell Pym to recalculate height after all content is loaded
          recalculateHeight();

          // Tell Pym to recalculate height after content is loaded
          if (window.pymChild) {
            // Multiple height calculations to ensure everything is measured correctly
            setTimeout(() => {
              window.pymChild.sendHeight();
            }, 100);
            setTimeout(() => {
              window.pymChild.sendHeight();
            }, 300);
            setTimeout(() => {
              window.pymChild.sendHeight();
            }, 600);
            setTimeout(() => {
              window.pymChild.sendHeight();
            }, 1000);
          }
        } catch (error) {
          console.error('Error parsing temperature data:', error);
          showError();
        }
      } else {
        console.error('Error fetching temperature data. Status:', xhr.status);
        showError();
      }
    }
  };

  function showError() {
    // Remove loading row and show error
    loadingRow.remove();

    const errorRow = tbody.append('tr');
    errorRow.append('td')
      .attr('colspan', '3')
      .style('padding', '30px')
      .style('text-align', 'center')
      .style('color', '#d32f2f')
      .style('font-style', 'italic')
      .text('Error loading temperature data. Please try again later.');

    // Tell Pym to recalculate height after error is shown
    if (window.pymChild) {
      setTimeout(() => {
        window.pymChild.sendHeight();
      }, 100);
    }
  }

  xhr.send();
}
